
const RXDC = {
  header: {
    category: "Intraorális Röntgen",
    model: "MyRay RXDC eXTEND",
    tagline: "Precíz képek, teljes kontroll.",
  },

  hero: {
    image: "/uploads/rxdc.png",
    buttonText: "Digitális bemutatóterem",
    title: "MyRay RXDC eXTEND",
    description:
      "Az RX DC eXTend készülékkel gyors és megbízható diagnosztikát biztosít az alkalmazott fejlett technológia, az egyszerű telepítés és a képalkotási paraméterek beállításához szükséges vezeték nélküli vezérlés. Mindezt a pontosság és a biztonság feláldozása nélkül.",
    showroom: "https://www.vitshowroom.it/interactive/myray/index.php?IDmodello=1074&param=sala1,162.94,-6.55,94.80,4,ENG"
  },

  description: {
    title: "Jellemzők",
    columns: [
      [
        "Könnyen telepíthető",
        "Időben tartó megbízhatóság",
        "Automatikus moduláció",
      ],
      [
        "Kevesebb sugárzás",
        "Könnyű vezérlés.",
      ],
    ],
    image: "/uploads/rxdc-pano.jpg",
  },

  sections: [
    {
      title: "Tulajdonságok",
      cards: [
        {
          title: "Könnyen telepíthető",
          description: "Az okos kialakításnak és a vezeték nélküli technológiának köszönhetően az RX DC eXTend könnyen telepíthető. A könnyű, önkiegyensúlyozó karok stabilitást és pontosságot biztosítanak, míg a különböző hosszúságokban (40, 60 és 90 cm) kapható vízszintes konzolok zökkenőmentes integrációt tesznek lehetővé bármilyen környezetbe. A különböző típusú fali telepítésekhez alkalmas fali lemeznek köszönhetően az RX DC eXTend a rendelő bármely pontján egyszerűen és egyszerűen beállítható.",
        },
        {
          title: "Időben tartó megbízhatóság",
          description: "A kiváló minőségű anyagokból készült RX DC eXTend a szilárdság és a tartósság jegyében készült, minimalizálva a rezgést és az instabilitást a képrögzítés során. Intenzív használat mellett is számíthat a konzisztens teljesítményre.",
        },
        {
          title: "Automatikus moduláció",
          description: "Az expozíciós paraméterek automatikus modulációja a páciens mérete alapján állítja be a teljesítményt és az időzítést, így éles képeket biztosít bármilyen érzékelővel.",
        },
        {
          title: "Kevesebb sugárzás",
          description: "A nagyfrekvenciás, állandó potenciálú generátor csökkenti a káros sugárzást, míg a 4 mA-es mód választható a röntgensugárzás kibocsátásának felére csökkentésére. Míg a téglalap alakú kollimátor a kibocsátott sugárzást csak a vizsgált területre korlátozza, a dinamikus kitöltési tényező lehetővé teszi a túlmelegedés nélküli egymást követő expozíciókat, a cső hőmérsékletének valós idejű monitorozásával.",
        },
        {
          title: "Könnyű vezérlés.",
          description: "Irányítsa rendszerét a vezeték nélküli vezérlővel, válasszon expozíciós programokat, és készítsen azonnali röntgenfelvételeket egyetlen érintéssel.",
        },
      ],
    },
  ],
};

export default RXDC;